export default "__VITE_ASSET__CFo_U4nx__"